import {
  Box,
  Checkbox,
  SelectChangeEvent,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import { ProductOption } from "lib/features/checkout/checkoutService";
import React, { useState } from "react";
import { additionalInformationStyles as styles } from "styles/Checkout/additionalInformation.styles";
import DropDownIcon from "../../../assets/icons/black_down_arrow.svg";

interface InfluencerType {
  id: string;
  type: string;
}

interface CustomerInformationFormProps {
  price: number;
  setPrice: (value: number) => void;
  formData: {
    group_type: string;
  };
  handleSelect: (event: SelectChangeEvent) => void;
  influencerTypesData: InfluencerType[];
  comment: string;
  setComment: (value: string) => void;
  offering: string | null;
  additionalOptions: ProductOption[];
  setAdditionalOptions (value: ProductOption[]) : void;
}

const CustomerInformationForm: React.FC<CustomerInformationFormProps> = ({
  price,
  setPrice,
  comment,
  setComment,
  additionalOptions = [],
  setAdditionalOptions,
}) => {
  const theme = useTheme();
  // console.log("additionalOptions", additionalOptions);
  const [selectedQuantity, setSelectedQuantity] = useState<Record<number, number>>({});
  const [commentValue, setCommentValue] = useState<string>("");
  const [textValue, setTextValue] = useState<Record<number, string>>({});
  const [previousSelectedQuantity, setPreviousSelectedQuantity] = useState<Record<number, number>>({});
  const [previousTextValue, setPreviousTextValue] = useState<Record<number, string>>({});
  const [isOpen, setIsOpen] = useState<Record<number, boolean>>({});
  const [checkedItems, setCheckedItems] = useState<Record<number, boolean>>({});

  const handleToggleDropdown = (index: number) => {
    setIsOpen((prev) => ({ ...prev, [index]: !prev[index] }));
  };

  const handleQuantityChange = (index: number, quantity: number, option: ProductOption) => {
    console.log("Before change", additionalOptions);
     const previousQuantity = previousSelectedQuantity[index] || 0; // Get previously selected quantity
     console.log("Before change", additionalOptions);
    // // Calculate the new total price
     const newTotalPrice = price - previousQuantity * option.price + quantity * option.price;
    setAdditionalOptions(additionalOptions); // Update the state with the modified additional options
    setPreviousSelectedQuantity((prev) => ({ ...prev, [index]: quantity })); // Track last selection
    setSelectedQuantity((prev) => ({ ...prev, [index]: quantity }));
     setPrice(newTotalPrice);

    // // Close dropdown
     setIsOpen((prev) => ({ ...prev, [index]: false }));

  };
  const handleTextInput = (index: number, value: string , option: ProductOption ) => {
    console.log("Before change", additionalOptions);
     const prevText = previousTextValue[index] || 0; // Get previously selected quantity

    // // Calculate the new total price
     const newValue  = prevText || ""  + value;
    setAdditionalOptions(additionalOptions); // Update the state with the modified additional options
    setPreviousTextValue((prev) => ({ ...prev, [index]: newValue })); // Track last selection
    setTextValue((prev) => ({ ...prev, [index]: newValue }));
    setAdditionalOptions(additionalOptions);
    console.log("After change", additionalOptions);
  }
  const handleCheckboxChange = (index: number, addOnPrice: number) => {
    const isChecked = !checkedItems[index]; // Toggle state
    
    setAdditionalOptions(additionalOptions);
    setCheckedItems((prev) => ({ ...prev, [index]: isChecked }));
    setPrice(isChecked ? price + addOnPrice : price - addOnPrice);
  };

  const textInputs = additionalOptions.filter((ao) => ao.type === 1 && (!ao.price || ao.price === 0));
  const quantitySelections = additionalOptions.filter((ao) => ao.type === 2 && (!ao.price || ao.price === 0));
  const checkboxes = additionalOptions.filter((ao) => ao.type === 3 && (!ao.price || ao.price === 0));

  return (
    <Box sx={styles.container}>
      <Typography sx={styles.heading(theme)}>Customer Information</Typography>
      <Typography sx={styles.requiredText(theme)}>*Required fields</Typography>

      {/* Text Inputs (Type 1) */}
      {textInputs.map((option: ProductOption, index) =>{
        return (
        <Box key={index}>
          <Typography sx={styles.label(theme)}>{option.header}</Typography>
          <TextField
            fullWidth
            placeholder={option.place_holder}
            sx={styles.textField}
            value={textValue[option.id] || ""}
            onChange={(e) => {
              option.textValue = e.target.value; // Update the text value in the option
              setTextValue((prev) => ({ ...prev, [option.id]: e.target.value }));
              handleTextInput(index, e.target.value, option);
            }}
          />
        </Box>
      )
      } )}

      {/* Quantity Selection Dropdowns (Type 2) */}
      {quantitySelections.map((item, index) => (
        <Box key={index}>
          <Typography sx={styles.label(theme)}>{item.header}</Typography>
          <Box sx={styles.dropdownContainer}>
            <Box sx={styles.dropdownToggle} onClick={() => handleToggleDropdown(index)}>
              <Typography sx={styles.selectedQuantityText}>{selectedQuantity[index] || 0}</Typography>
              <img src={DropDownIcon} alt="dropdown" />
            </Box>
            {isOpen[index] && (
              <Box sx={styles.dropdownMenu(theme)}>
                {Array.from({ length: item.availability + 1 }, (_, qty) => (
                  <Box
                    key={qty}
                    sx={styles.dropdownItem(theme)}
                    onClick={() => {
                      item.selectedValue = qty; // Update the selected value in the item
                      handleQuantityChange(index, qty, item)}}
                  >
                    {qty}
                  </Box>
                ))}
              </Box>
            )}
          </Box>
        </Box>
      ))}

      {/* Checkboxes (Type 3) */}
      {checkboxes.length > 0 && (
        <Typography sx={styles.label(theme)}>Other Add-ons:</Typography>
      )}
      {checkboxes.map((option: ProductOption, index) => (
        <Box key={index} sx={styles.checkboxContainer}>
          <Checkbox
            checked={checkedItems[index] || false}
            onChange={() => { 
              if(option.selectedValue === undefined || option.selectedValue === 0) {
              option.selectedValue = 1; // Set to 1 if not already set
              } else {    
               option.selectedValue = 0;}
              handleCheckboxChange(index, option.price)

            }
             }
            sx={styles.checkbox}
          />
          <Box sx={styles.checkboxContent}>
            <Typography sx={styles.checkboxHeader(theme)}>{option.header}</Typography>
            <Typography variant="body2" sx={styles.checkboxDescription}>
              {option.description ?? ""}
            </Typography>
          </Box>
        </Box>
      ))}

      {/* Comments Field */}
      <Typography sx={styles.commentText(theme)}>Comments or Additional requests</Typography>
      <TextField
        fullWidth
        variant="outlined"
        multiline
        minRows={4}
        value={comment}
        onChange={(event) => setComment(event.target.value)}
        sx={styles.commentField}
      />
    </Box>
  );
};

export default CustomerInformationForm;
